import 'react-tooltip/dist/react-tooltip.css';

import Main from 'components/Main/Main';
import { AnalyticsProvider } from 'contexts/Analytics/Analytics';
import { ApiProvider } from 'contexts/Api/Api';
import { ContentProvider } from 'contexts/Content/Content';
import { GameProvider } from 'contexts/Game/Game';
import { PageProvider } from 'contexts/Page/Page';
import { SettingsProvider } from 'contexts/Settings/Settings';
import { ThemeProvider } from 'contexts/Theme/Theme';
import type { AppProps } from 'next/app';
import { initSentry } from 'setup/sentry';

initSentry();

export default function App({ Component, pageProps }: AppProps) {
    return (
        <AnalyticsProvider>
            <ThemeProvider>
                <SettingsProvider>
                    <ApiProvider>
                        <ContentProvider>
                            <PageProvider>
                                <GameProvider>
                                    <Main>
                                        <Component {...pageProps} />
                                    </Main>
                                </GameProvider>
                            </PageProvider>
                        </ContentProvider>
                    </ApiProvider>
                </SettingsProvider>
            </ThemeProvider>
        </AnalyticsProvider>
    );
}
